import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import theme from '../../theme.css';
import FAQsView from "./FAQsView";
import SupportRequestTableView from "./SupportRequestTableView";
import SupportRequestView from "./SupportRequestView";

const useStyles = makeStyles((theme) => ({
    '@global': {
        "*::-webkit-scrollbar": {
            width: theme.spacing(1),
            height: theme.spacing(0.5),
        },
        "*::-webkit-scrollbar-thumb": {
            background: theme.palette.background.onCard,
        },
        "*::-webkit-scrollbar-track": {
            background: theme.palette.background.primary
        },
    },
    main: {
        padding: theme.spacing(2)
    },
    content: {
        background: theme.palette.common.white,
        padding: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            width: window.outerWidth - 25,
        },
    }
}));

export default function SupportView(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const { active, onChangeTab, serviceRequestsCompleted, serviceRequests } = props;

    return (
        <Grid item xs={12} className={classes.main}>
            <Grid item xs={12} container className={classes.content}>
                <SupportRequestView 
                    active={active}
                    // serviceRequestsCompleted={serviceRequestsCompleted}
                    serviceRequests={serviceRequests}
                    onChangeTab={onChangeTab}
                    onAddSupportRequest={props.onAddSupportRequest}
                />
            </Grid>
            <Grid item xs={12} container className={classes.content}>
                <FAQsView 
                />
            </Grid>
        </Grid>
    );
}